import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice Simplification de Fractions";
const DESCRIPTION =
  "Calculatrice Simplification de Fractions pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "simplification de fractions, calculatrice simplification de fractions, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/simplifying-fractions";

function gcd(a, b) {
  return b === 0 ? a : gcd(b, a % b);
}

function SimplifyingFractionsCalculator() {
  const [numerator, setNumerator] = useState("");
  const [denominator, setDenominator] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const num = parseInt(numerator);
      const denom = parseInt(denominator);
      if (isNaN(num) || isNaN(denom) || denom === 0) {
        setError("Entrez les valeurs valides");
        setResult("");
        return;
      }
      const divisor = gcd(Math.abs(num), Math.abs(denom));
      const simplifiedNum = num / divisor;
      const simplifiedDenom = denom / divisor;
      setResult(`${simplifiedNum}/${simplifiedDenom}`);
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Numérateur:</label>
                    <input
                      type="number"
                      value={numerator}
                      onChange={(e) => setNumerator(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>Dénominateur:</label>
                    <input
                      type="number"
                      value={denominator}
                      onChange={(e) => setDenominator(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Simplifier
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {result && (
                  <p className="p-3 mb-2 bg-success text-white">
                    Fraction simplifiée: {result}
                  </p>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Calculatrice de simplification de fractions</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        <strong>Qu'est-ce que cette calculatrice ?</strong>
                        Elle convertit les fractions en leur forme la plus simple et
                        en nombres mixtes, avec les étapes détaillées du calcul.
                      </p>
                      <p>
                        <strong>Comment utiliser :</strong>
                        Entrez le numérateur et le dénominateur, puis cliquez sur "Calculer".
                      </p>
                      <p>
                        <strong>Explication des résultats :</strong>
                        La calculatrice affiche le résultat simplifié ainsi que
                        toutes les étapes de simplification pour mieux comprendre le processus.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default SimplifyingFractionsCalculator;
